module.exports = __webpack_public_path__ + "img/nodata.64852870.png";